import React, { createContext } from "react";
import { Outlet, Link } from 'react-router';
import pixels from './images/localhost_3000_11.png';
import mcm from './images/Screenshot 2024-06-09 165316.png';
import dictionary from "./images/Screenshot 2023-10-04 125209.png"
import movie from "./images/Screenshot 2023-10-04 133132.png"
import budget from "./images/Screenshot 2023-10-14 120824.png"
import { useState } from "react";


const project_data = [
    {
        image: pixels,
        heading: 'Jewelry store',
        title: 'Jewelry store',
        languages: [
            'React',
            'Tailwindcss'
        ],
        weblink: 'jewelry-git-master-xoloyinks.vercel.app/',
        gitlink: "github.com/xoloyinks/jewelry-e-commerce"
    },
    {
        image: movie,
        heading: 'MovieBox',
        title: 'MovieBox',
        languages: [
            'Next js',
            'Tailwindcss'
        ],
        weblink: 'zuri-phase-2.vercel.app/',
        gitlink: 'github.com/xoloyinks/Zuri-Phase-2/tree/main'
    },
    {
        image: mcm,
        heading: 'MCM Kitchen & Hair Beauty Salon',
        title: 'MCM Kitchen & Beauty Salon',
        languages: [
            'Next js',
            'Tailwind CSS'
        ],
        weblink: 'www.mcmsvc.com',
        gitlink: 'github.com/xoloyinks/mcm'
    },
    {
        image: dictionary,
        heading: 'Dictionary',
        title: 'x-find (Dictionary app)',
        languages: [
            'Next js',
            'Tailwindcss'
        ],
        weblink: 'dictionary-app-two-psi.vercel.app/',
        gitlink: 'github.com/xoloyinks/dictionary_app'
    },
    
]

var blobColor = '#1f2937';
const priColor = "green-800";

const Map_project = () => {
    return project_data.map(
        (data , i) => <Project key={i} id={i}  img={data.image} title={data.title} lead={data.to} heading={data.heading} languages={data.languages} gitlink={data.gitlink} weblink={data.weblink} />
    )
}
const Languages = ({prog}) => {
    return(
        <>
            <div className={"bg-green-900 text-white mt-3 text-sm rounded-full w-[50%] p-2 mx-auto max-[380px]:text-[13px]"}>{prog}</div>
        </>
    )
}


const Project = ({img,id, title, gitlink, weblink, languages}) => {
    const [check, setCheck] = useState(id);
    return(
        <>
                    <div className="each_section rounded-lg sec w-[90%] lg:w-[24%] lg:mx-0 mx-auto h-[42vh] my-4 bg-slate-900 shadow-md shadow-slate-800">
                        <div  className="project_logo bg-gradient-to-br from-slate-700 to-slate-800 relative rounded-t-xl h-[70%] w-full flex items-center justify-center text-xl overflow-hidden text-slate-400 font-bold">
                            <img src={img} alt="" className="absolute max-h-[95%]" />
                        </div>
                        <div className="flex flex-col justify-center p-5 text-sm text-center text-white h-fit rounded-b-xl bg-slate-800">
                            <span>{title}</span>
                            <div className="flex justify-center gap-2 mt-2">
                            {
                                languages.map((datum, i) => <span key={i} className="px-3 py-1 text-gray-400 rounded-full bg-slate-700 text-[10px] w-fit">{datum}</span> )
                            }
                            </div>
                            
                            <span className="mt-3 gap-2 flex mx-auto text-[11px]">
                                <a href={`https://${weblink}`} target="_blank" className="flex items-center px-3 py-2 text-white bg-green-800 rounded-lg">Live Demo</a>
                                <a href={`https://${gitlink}`} target="_blank" className="flex items-center px-3 border-2 rounded-lg border-slate-400 text-slate-400">View Repo</a>
                            </span>
                        </div>
                    </div>
            
        <Outlet />
        </>
    )
}
export default function Projects(){
    return(
        <>
           <section id="project"  className="bg-slate-900 px-[20px] flex justify-between flex-wrap w-[100%] relative md:px-[50px] lg:px-[100px] xl:px-[150px]">
                <div className="z-30 py-4 mx-auto mt-5 text-center lg:py-2">
                    <h1 className="text-white opacity-60 text-3xl max-[380px]:text-xl max-[640px]:text-2xl">Some of my Works</h1>
                </div><br /><br />
                <div className="flex flex-wrap gap-10 justify-center w-full mt-3 max-[380px]:mt-0">
                    <Map_project />
                </div>
                
           </section>
        </>
    )
}


